import { Form, message, Input, Button } from "antd";
import React, { useState, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Link, useHistory } from "react-router-dom";
import Order from "../../../api/orderApi";
import { LoadingConfig } from "../../../components";
import { KEY_RECAPTCHA, RULES_ANTD } from "../../../constants";
const FormChangePass = () => {
  const [loading, setLoading] = useState();
  const [captcha, setCaptcha] = useState(false);
  const [form] = Form.useForm();
  const history = useHistory();
  useEffect(() => {
    getList();
  }, []);
  const getList = async () => {
    const token = await localStorage.getItem("USER_TOKEN");
    const userId = await localStorage.getItem("USER_ID");

    if (!token || !userId) {
      Order.logOutUser();
      return history.replace("/login");
    }
  };

  const onSubmit = async (value) => {
    // setLoading(true);
    const data = {
      password: value ? value.AMV_password_new : "",
      password_confirmation: value ? value.AMV_password_new_confirm : "",
    };
    // console.log(data);
    const temp = JSON.parse(localStorage.getItem("INFO_LOGIN"));
    temp.password = value ? value.AMV_password_new_confirm : "";

    const res = await Order.ChangePassword(data);
    if (res && res.meta && res.meta.statusCode === 200) {
      localStorage.setItem("INFO_LOGIN", JSON.stringify(temp));
      setLoading(false);
      message.success("Chúc mừng bạn đã đổi mật khẩu thành công" || "");
      history.replace("/manage-register");
    } else {
      setLoading(false);
      return message.error(res.meta.msg || "");
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("Bạn chưa nhập đầy đủ thông tin");
    return;
  };
  const handleChangeCaptcha = () => {
    setCaptcha(!captcha);
  };

  return (
    <div>
      {loading && <LoadingConfig title="" />}

      <Form
        className="ChangePassUserForm"
        labelCol={{
          span: 24,
        }}
        wrapperCol={{
          span: 24,
        }}
        onFinish={onSubmit}
        onFinishFailed={onFinishFailed}
        form={form}
      >
        <div className="content__content--one row">
          {/* Mật khâu */}

          <div className="col-md-12 col-sm-12">
            <Form.Item
              label="Mật khẩu mới"
              name="AMV_password_new"
              hasFeedback
              rules={RULES_ANTD.password}
            >
              <Input.Password placeholder="Mật khẩu ít nhất 8 kí tự (*)" />
            </Form.Item>
          </div>

          {/* Nhập lại mật khẩu  */}
          <div className="col-md-12 col-sm-12">
            <Form.Item
              label="Nhập lại mật khẩu mới"
              name="AMV_password_new_confirm"
              hasFeedback
              rules={RULES_ANTD.confirm_password_new}
            >
              <Input.Password placeholder="Nhập lại mật khẩu" />
            </Form.Item>
          </div>
          <div className="col-12">
            <div className="captcha pt-3 pb-3">
              <ReCAPTCHA
                sitekey={KEY_RECAPTCHA}
                onChange={handleChangeCaptcha}
              />
            </div>
          </div>
          <div className="col-12">
            <Button
              type="primary"
              shape="round"
              htmlType="submit"
              className="btn btn_bottom mr-3  mb-4"
              disabled={captcha ? false : true}
            >
              Đổi mật khẩu
            </Button>
            <Link to="/login">
              <Button
                onClick={() => history.replace("/manage-register")}
                type="primary"
                htmlType="button"
                shape="round"
                className="btn btn_bottom   mb-4"
              >
                Bỏ qua
              </Button>
            </Link>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default FormChangePass;
